import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { CustomerApplicationQueryKeys } from "./keys";
import { ICustomerApplication } from "../../models/CustomerApplication/CustomerApplication";

export default function useCustomerApplications(customerId: string) {
  const { get } = useApiHelper();

  const customerApplications = useQuery({
    queryKey: CustomerApplicationQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerApplication[]>>(
        `/customer/${customerId}/applications`
      ).then((res) => res.data),
  });

  return {
    customerApplications,
  };
}
